import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";

type KeylockerRemarkMutationPayload = {
  keylocker_communication_id: number;
  keylocker_remark_id: number;
  handled_remark: boolean; // TODO: ask backend to be consistent and name this handled
};

export const useKeylockerRemarkMutation = () =>
  useTypedMutation<KeylockerRemarkMutationPayload, void>({
    mutationFn: async payload => {
      await ApiInstance.post("/dashboard/remark/handle", payload, ENV.keylockerBaseURL);
    },
    onSuccess: ({ keylocker_communication_id, keylocker_remark_id, handled_remark }) => {
      const appointment = typedQueryClient.getQueryData(AppointmentDetailsKeys.view);
      if (!appointment?.keylocker_communications?.length) return;

      const keylockerCommIdx = appointment.keylocker_communications.findIndex(kc => kc.id === keylocker_communication_id);
      if (keylockerCommIdx < 0 || appointment.keylocker_communications[keylockerCommIdx].remark?.id !== keylocker_remark_id) return;

      const keylocker_communications = appointment.keylocker_communications.with(keylockerCommIdx, {
        ...appointment.keylocker_communications[keylockerCommIdx],
        remark: {
          ...appointment.keylocker_communications[keylockerCommIdx].remark,
          receptionist_handled: handled_remark
        }
      });

      typedQueryClient.setQueryData(AppointmentDetailsKeys.view, { ...appointment, keylocker_communications });
    }
  });
